import { render, staticRenderFns } from "./MemberPrivilegeForm.vue?vue&type=template&id=47eb59e0&scoped=true&"
import script from "./MemberPrivilegeForm.vue?vue&type=script&lang=js&"
export * from "./MemberPrivilegeForm.vue?vue&type=script&lang=js&"
import style0 from "./MemberPrivilegeForm.vue?vue&type=style&index=0&id=47eb59e0&prod&scoped=true&lang=css&"
import style1 from "./MemberPrivilegeForm.vue?vue&type=style&index=1&id=47eb59e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb59e0",
  null
  
)

export default component.exports